import styled from 'styled-components'

export const Status = styled.div`
  padding-bottom: 4px;
`
